import React from 'react';
import '../styles/NewsEvents.css';

const newsEvents = [
    {
        title: 'Coming Soon',
        description: 'Stay tuned for upcoming news and events.',
        imageUrl: 'https://via.placeholder.com/400x300?text=Coming+Soon',
        link: '#'
    },
    {
        title: 'Coming Soon',
        description: 'Stay tuned for upcoming news and events.',
        imageUrl: 'https://via.placeholder.com/400x300?text=Coming+Soon',
        link: '#'
    },
    {
        title: 'Coming Soon',
        description: 'Stay tuned for upcoming news and events.',
        imageUrl: 'https://via.placeholder.com/400x300?text=Coming+Soon',
        link: '#'
    },

    // Add more placeholders if needed
];

const NewsEvents = () => (
    <div className="news-events-page">
        <h1 className="news-events-title">News & Events</h1>
        <div className="news-events-container">
            {newsEvents.map((item, index) => (
                <div key={index} className="news-card">
                    <div className="card-top">
                        <img src={item.imageUrl} alt={item.title} className="card-image" />
                    </div>
                    <div className="card-bottom">
                        <h5 className="news-title">{item.title}</h5>
                        <p className="news-description">{item.description}</p>
                        {/* Disable link until actual content is available */}
                        <span className="news-link">Link Coming Soon</span>
                    </div>
                </div>
            ))}
        </div>
    </div>
);

export default NewsEvents;